import { FormControl } from '@mui/material'
import { useField } from 'formik'
import React from 'react'
import { FieldError } from '../FieldError/FieldError'
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker'
import { CustomFieldLabel } from '../CustomFieldLabel/CustomFieldLabel'


export function CustomFieldDatePicker({ label, required, ...props }) {
    const [field, meta, helpers] = useField(props)
    const { ...restField } = field
    return (
        <FormControl  fullWidth={ props.fullWidth }>
            {label && <CustomFieldLabel required={required}>{label}</CustomFieldLabel>}
            <CustomDatePicker
                {...restField}
                {...props}
                onChange={(value) => { 
                    helpers.setValue(value)
                }}
            />
            {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
        </FormControl>
    )
}

CustomFieldDatePicker.defaultProps = {
    required: false,
}
